import { SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { graphql, useStaticQuery } from "gatsby";

import React from "react";
import BlogCard from "../BlogCard";

const RelatedPost = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpPost {
        nodes {
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    formats: [AUTO, WEBP]
                    width: 800
                  )
                }
              }
            }
          }

          id
          date(formatString: "D MMMM YYYY")
          modified
          modifiedGmt
          title
          excerpt
          uri
          slug
          content
          tags {
            nodes {
              name
              slug
            }
          }
          categories {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  `);

  const shuffleArray = (array: any) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const shuffledPosts = shuffleArray(data.allWpPost.nodes);

  return (
    <>
      <Stack gap={0} w={{ base: "100%", xl: "288px" }} pt={10}>
        <Text
          fontSize="24px"
          className="light-text"
          pb="20px"
          lineHeight="100%"
        >
          Related Articles
        </Text>
        <SimpleGrid
          columns={{ base: 1, sm: 1, md: 3, xl: 1 }}
          gap={{ base: "20px", xl: "12px" }}
        >
          {shuffledPosts.slice(0, 3).map((item: any, index: number) => {
            const category = item.categories.nodes[0]?.slug || "uncategorized";
            const fullHref = `/blog/${category.toLowerCase()}/${item.slug}`;
            const imageData =
              item.featuredImage?.node?.localFile?.childImageSharp
                ?.gatsbyImageData;
            return (
              <BlogCard
                key={index}
                title={item.title}
                date={item.date}
                description={item.excerpt}
                imageData={imageData}
                category={item.categories.nodes.map((item: any) =>
                  item.name.toUpperCase()
                )}
                slug={fullHref}
              />
            );
          })}
        </SimpleGrid>
      </Stack>
    </>
  );
};

export default RelatedPost;
